export const SET_ADMIN_USER_EDIT_REQUEST = 'SET_ADMIN_USER_EDIT_REQUEST';
export const SET_ADMIN_USER_EDIT_SUCCESS = 'SET_ADMIN_USER_EDIT_SUCCESS';
export const SET_ADMIN_USER_EDIT_FAILED = 'SET_ADMIN_USER_EDIT_FAILED';
export const SET_ADMIN_USER_REQUEST = 'SET_ADMIN_USER_REQUEST';
export const SET_ADMIN_USER_SUCCESS = 'SET_ADMIN_USER_SUCCESS';
export const SET_ADMIN_USER_FAILED = 'SET_ADMIN_USER_FAILED';
export const CLEAN_EDIT_USERS = 'CLEAN_EDIT_USERS';
